import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import ContextProviders from 'context/Providers';
import ServiceWorkerProvider from 'toolbox/src/components/ServiceWorkerProvider/ServiceWorkerProvider';
import './index.css';

import App from 'App';

import JavascriptTimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

// Initialise AWS Amplify library
// Load options from a config that is automatically generated by the Amplify CLI tool
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import awsconfig from 'aws-exports';
Amplify.configure({
  ...awsconfig,
  API: {
    endpoints: [...awsconfig.aws_cloud_logic_custom],
    aws_appsync_graphqlEndpoint:
      process.env.REACT_APP_HASURA_ENDPOINT ||
      'https://api.jcap.co.uk/v1/graphql',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_appsync_region: awsconfig.aws_cognito_region,
    graphql_headers: async () => {
      const { idToken } = (await Auth.currentSession()) as any;
      return { Authorization: `Bearer ${idToken?.jwtToken}` };
    },
  },
});

JavascriptTimeAgo.locale(en);

ReactDOM.render(
  <Suspense fallback={null}>
    <ServiceWorkerProvider>
      <Router>
        <ContextProviders>
          <App />
        </ContextProviders>
      </Router>
    </ServiceWorkerProvider>
  </Suspense>,
  document.getElementById('app'),
);
